import { RHFCode } from './rhf-code';
import { RHFRating } from './rhf-rating';
import { RHFEditor } from './rhf-editor';
import { RHFSlider } from './rhf-slider';
import { RHFTextField } from './rhf-text-field';
import { RHFRadioGroup } from './rhf-radio-group';
import { RHFPhoneInput } from './rhf-phone-input';
import { RHFAutocomplete } from './rhf-autocomplete';
import { RHFMultiAutocomplete } from './rhf-multi-autocomplete';
import { RHFCountrySelect } from './rhf-country-select';
import { RHFSwitch, RHFMultiSwitch } from './rhf-switch';
import { RHFSelect, RHFMultiSelect } from './rhf-select';
import { RHFCheckbox, RHFMultiCheckbox } from './rhf-checkbox';
import { RHFUpload, RHFUploadBox, RHFUploadAvatar } from './rhf-upload';
import { RHFDatePicker, RHFMobileDateTimePicker } from './rhf-date-picker';
import { RHFDateTimePicker } from 'src/components/hook-form/rhf-date-time-picker';
import { RHFCurrencyMultiplierSelect } from 'src/components/hook-form/rhf-currency-multiplier-select';
import { RHFMarketsConfigSelect } from 'src/components/hook-form/rhf-markets-config-select';
import { RHFJsonTextarea } from 'src/components/hook-form/rhf-json-field';
import { RHFTimePicker } from 'src/components/hook-form/rhf-time-picker';
import { RHFNumberChips } from 'src/components/hook-form/rhf-number-chips';
import { RHFTextChips } from 'src/components/hook-form/rhf-text-chips';

// ----------------------------------------------------------------------

export const Field = {
  Code: RHFCode,
  Editor: RHFEditor,
  Select: RHFSelect,
  Upload: RHFUpload,
  Switch: RHFSwitch,
  Slider: RHFSlider,
  Rating: RHFRating,
  Text: RHFTextField,
  Phone: RHFPhoneInput,
  Checkbox: RHFCheckbox,
  UploadBox: RHFUploadBox,
  RadioGroup: RHFRadioGroup,
  DatePicker: RHFDatePicker,
  DateTimePicker: RHFDateTimePicker,
  TimePicker: RHFTimePicker,
  MultiSelect: RHFMultiSelect,
  MultiSwitch: RHFMultiSwitch,
  UploadAvatar: RHFUploadAvatar,
  Autocomplete: RHFAutocomplete,
  MultiAutocomplete: RHFMultiAutocomplete,
  MultiCheckbox: RHFMultiCheckbox,
  CountrySelect: RHFCountrySelect,
  MobileDateTimePicker: RHFMobileDateTimePicker,
  CurrencyMultiplierSelect: RHFCurrencyMultiplierSelect,
  MarketsConfigSelect: RHFMarketsConfigSelect,
  JsonTextarea: RHFJsonTextarea,
  NumberChips: RHFNumberChips,
  TextChips: RHFTextChips,
};
